(() => {
  const selector = 'img[data-card-hover-image]';

  function loadHoverImage(card) {
    const image = card?.querySelector(selector);
    if (!(image instanceof HTMLImageElement) || image.dataset.cardHoverRequested === 'true') return;

    image.dataset.cardHoverRequested = 'true';
    const srcset = image.dataset.cardHoverSrcset;
    const src = image.dataset.cardHoverSrc;

    image.addEventListener(
      'load',
      () => {
        image.dataset.cardHoverLoaded = 'true';
        image.removeAttribute('data-card-hover-src');
        image.removeAttribute('data-card-hover-srcset');
      },
      { once: true }
    );

    if (srcset) image.srcset = srcset;
    if (src) image.src = src;
  }

  document.addEventListener(
    'pointerover',
    (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const card = target.closest('.card-gallery');
      if (card) loadHoverImage(card);
    },
    { passive: true }
  );

  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const card = target.closest('.card-gallery');
    if (card) loadHoverImage(card);
  });
})();
